"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffersSchema = exports.getProductItemListSchema = exports.getProductSchema = void 0;
const getProductSchema = (product) => {
    return {
        name: product.name,
        ...(product.description && { description: product.description }),
        image: product.image,
        ...(product.urlCard && { url: product.urlCard }),
        offers: {
            '@type': 'Offer',
            price: product.price,
            ...(product.inStock && { availability: 'https://schema.org/InStock' }),
            priceCurrency: product.priceCurrency,
        },
    };
};
exports.getProductSchema = getProductSchema;
const getProductItemListSchema = (products) => {
    return products.map((product) => {
        return {
            '@type': 'Product',
            ...(0, exports.getProductSchema)(product)
        };
    });
};
exports.getProductItemListSchema = getProductItemListSchema;
const getOffersSchema = (products) => {
    return products.map((product) => {
        return {
            '@type': 'Offer',
            name: product.name,
            ...(product.description && { description: product.description }),
            ...(product.image && { image: product.image }),
            url: product.urlCard,
            price: product.price,
            ...(product.inStock && { availability: 'https://schema.org/InStock' }),
            priceCurrency: product.priceCurrency,
        };
    });
};
exports.getOffersSchema = getOffersSchema;
